export default [
    { name: 'Discount', value: 'discount' },
    { name: 'Combo Set', value: 'combo' },
    { name: 'Override Price', value: 'override' },
    { name: 'Free Product', value: 'free_product' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/store/promotion-types.js